import React, {Component} from 'react';
// import {Table, Row, Col, Card, CardHeader, CardBody, Button, CardFooter} from 'reactstrap';
import {NavLink} from 'react-router-dom';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import $ from 'jquery';

class Upgrade extends Component {

  render() {
       

    return (

      <div className="animated fadeIn">
         <h1>Unlock new features</h1>
         <p>Upgrade your plan to use our exciting features</p>
         <i className="far fa-grin-wink fa-lg"></i>
      </div>
    )
  }
}

export default Upgrade;



// WEBPACK FOOTER //
// ./src/views/Components/Upgrade/Upgrade.js